import store from '@/store';

export default class VoiceConferenceStartEvent {
  constructor(body) {
    console.log('%c [event]', 'color: #F44336;', JSON.stringify(body, null, 4));

    store.dispatch('attendance/setUserAdded', body);
  }
}
